import { Video, CalendarDays, Clock, Languages, Tag } from "lucide-react";
import { SESSION } from "@/config/session";
import { CtaButton, Reveal } from "./Primitives";
import { Countdown } from "./Countdown";

const ROWS = [
  [Video, "Format", "Live on Zoom"],
  [CalendarDays, "Date", SESSION.dateLabel],
  [Clock, "Time", SESSION.timeLabel],
  [Languages, "Language", "Hindi · English"],
];

export const Price = ({ className = "" }) => (
  <span className={`inline-flex items-baseline gap-2 ${className}`} data-testid="price-display">
    <span className="font-black text-green-600">FREE</span>
    <span className="line-through text-zinc-500 font-medium">₹999</span>
  </span>
);

export const DetailsCard = () => (
  <Reveal className="rounded-2xl bg-white border border-plum/10 shadow-[0_20px_50px_-25px_rgba(42,15,92,0.35)] overflow-hidden" data-testid="details-card">
    <div className="px-5 pt-4 pb-3 bg-gradient-to-r from-orange-50 to-white border-b border-orange-100">
      <span className="inline-block rounded-full bg-tang/15 text-tang font-bold text-[12px] px-3 py-1">Masterclass Details Below</span>
    </div>
    <dl className="divide-y divide-zinc-100">
      {ROWS.map(([Icon, k, v]) => (
        <div key={k} className="flex items-center justify-between gap-3 px-5 py-3 text-[13.5px] sm:text-sm">
          <dt className="flex items-center gap-2 text-zinc-600"><Icon className="w-4 h-4 text-plum" />{k}</dt>
          <dd className="font-semibold text-ink text-right" data-testid={`detail-${k.toLowerCase()}`}>{v}</dd>
        </div>
      ))}
      <div className="flex items-center justify-between px-5 py-3 text-sm">
        <dt className="flex items-center gap-2 text-zinc-600"><Tag className="w-4 h-4 text-plum" />Price</dt>
        <dd><Price /></dd>
      </div>
    </dl>
  </Reveal>
);

export const RegisterCard = () => (
  <Reveal delay={0.1} className="rounded-2xl bg-white border border-plum/10 shadow-[0_20px_50px_-25px_rgba(42,15,92,0.35)] p-4 sm:p-5 space-y-3" data-testid="register-card">
    <p className="text-center font-bold text-ink text-sm">100% FREE Registration</p>
    <CtaButton testId="hero-cta-button" />
    <Countdown testId="hero-countdown" />
    <p className="text-center text-[12px] text-zinc-600 leading-snug">
      By registering, you agree to receive masterclass updates on WhatsApp and email.
    </p>
  </Reveal>
);
